type Props = { items: string[] };


export function Marquee({ items }: Props) {
  // duplicate the list so the keyframes can translate -50% seamlessly
  const doubled = [...items, ...items];
  return (
    <div className="overflow-hidden border-y border-white/10 py-5 md:py-7 select-none">
      <div className="marquee">
        {doubled.map((s, i) => (
          <span
            key={i}
            className="font-display text-3xl md:text-5xl tracking-tight text-bone-dim"
          >
            <span className="mx-12 inline-flex items-center gap-12">
              <span>{s}</span>
              <span className="text-aurora">✦</span>
            </span>
          </span>
        ))}
      </div>
    </div>
  );
}
